<div class=" question question_{{ question.type }} slide "
    [class.open-hint]="hintShowed === true">
    <div class="question__content px-4 py-2">
        <div class="flex items-center justify-between gap-3">
            <div class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs uppercase font-normal"
                style="background: color-mix(in srgb, var(--v2-color-secondary-400), white 92%); color: var(--v2-color-secondary-500);"
                *ngIf="sectionContent?.isScorable">
                <span class="w-1.5 h-1.5 rounded-full" style="background: var(--v2-color-secondary-500);"></span>
                <span> {{ 'words.evaluation' | translate }} </span>
            </div>
        </div>

        <div *ngIf="question.hint || question.hintMedia" class="hint">
            <button class="btn btn_color_grey hint__trigger" (click)="toggleHint()">
                {{ 'player.question.hint.button' | translate }}
            </button>

            <div class="hint__content" style="padding: 2.5rem; overflow: auto;">
                <button class="close" (click)="toggleHint()">+</button>
                <h4>{{ 'player.question.hint.title' | translate }}</h4>

                <div class="">
                    <p [innerHTML]="question.hint | safe:'html'"></p>
                </div>
            </div>
        </div>

        <div class="flex items-start justify-between gap-3">
            <msc-heading-actions class="block flex-1 min-w-0" [showMenu]="false">
                <h3 class="heading flex-1 min-w-0">
                    <span style="display:none !important" class="text-xs py-2 text-gray-500">{{ 'player.question.instruction.' +
                        question.type | translate}}</span>
                    <h1 class="text-md text-gray-700 mt-1 mb-2"  [innerHTML]="question?.title | safe:'html'" *ngIf="question?.title"></h1>
                    <span class="multiline multiline--question" [innerHTML]="question?.description | safe: 'html'"></span>
                </h3>
            </msc-heading-actions>

            <div class="flex-shrink-0 flex flex-col items-end gap-1">
                <span class="remaining-tries text-xs text-gray-500"
                    *ngIf="!questionSession.doneAt && questionSession.attempt < question.tryMax && question.tryMax > 1"
                    [innerHTML]="(question.tryMax - questionSession.attempt > 1) ?  ('player.question.attempts' | translate:{value: question.tryMax - questionSession.attempt}) : ('player.question.attempt' | translate)"></span>

                <span class="remaining-tries text-xs text-gray-500"
                    *ngIf="questionSession.type === 'open-write' && questionSession.doneAt && !questionSession.correctedAt">
                    {{ 'player.question.waiting-teacher-correction' | translate }}
                </span>
            </div>
        </div>





        <!-- <div #questionDetail></div> -->
        <ng-template questionHost></ng-template>

        <div class="no-options rounded-xl border-l-4 p-4" *ngIf="!hasAnswerOptions"
            style="border-left-color: #e21d48; background: rgb(255, 247, 249);">
            {{ 'player.question.no-options-configured' | translate }}
        </div>

        <div class="feedback rounded-xl border-l-4 p-4" *ngIf="questionSession?.doneAt && (questionSession?.type !== 'open-write' || questionSession?.correctedAt)"
            [style.border-left-color]="questionSession.isCorrect ? 'rgb(16, 185, 129)' : '#e21d48'"
            [style.background]="questionSession.isCorrect ? 'rgb(240, 253, 244)' : 'rgb(255, 247, 249)'"
            [style.border-top]="questionSession.isCorrect ? '1px solid rgb(209, 250, 229)' : '1px solid rgb(255, 217, 223)'"
            [style.border-right]="questionSession.isCorrect ? '1px solid rgb(209, 250, 229)' : '1px solid rgb(255, 217, 223)'"
            [style.border-bottom]="questionSession.isCorrect ? '1px solid rgb(209, 250, 229)' : '1px solid rgb(255, 217, 223)'">
            <div class="flex items-start gap-3">
                <span class="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5"
                    [style.background]="questionSession.isCorrect ? 'rgb(16, 185, 129)' : '#e21d48'">
                    <svg *ngIf="questionSession.isCorrect" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"
                        stroke-linejoin="round" class="w-3 h-3 text-white">
                        <path d="M20 6 9 17l-5-5"></path>
                    </svg>
                    <span *ngIf="!questionSession.isCorrect" class="text-white text-xs font-bold leading-none">!</span>
                </span>
                <div>
                    <h4 class="text-sm font-bold mb-0"
                        [style.color]="questionSession.isCorrect ? 'rgb(4, 120, 87)' : '#9F1239'">
                        {{ (questionSession.isCorrect ? 'word.correct-answer' : 'studio.sidebar-settings.common.correction.wrong') | translate }}
                    </h4>

                    <div class="hidden feedback__content feedback__text text-xs leading-relaxed"
                        [style.color]="questionSession.isCorrect ? 'rgb(4, 120, 87)' : '#9F1239'"
                        *ngIf="(!questionSession.isCorrect && !question.feedbackWrongAnswer) || questionSession.isCorrect">
                        <div [innerHTML]="question.feedbackDefault | safe:'html'"></div>
                        <div *ngIf="questionSession.comment" [innerHTML]="questionSession.comment | safe:'html'"></div>
                    </div>

                    <div class="hidden feedback__content feedback__text text-xs leading-relaxed"
                        [style.color]="questionSession.isCorrect ? 'rgb(4, 120, 87)' : '#9F1239'"
                        *ngIf="!questionSession.isCorrect && question.feedbackWrongAnswer">
                        <div [innerHTML]="question.feedbackWrongAnswer | safe:'html'"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="question__validation" style="margin: 1rem 0 0 0;">
<button class="remaining-tries" *ngIf="showBtnCorrectAnswer" (click)="toggleCorrectAnswer()">
                {{ questionDetailRef.instance.showCorrectAnswer ? ('player.question.button.hide-correct-answer' |
                translate) : ('player.question.button.show-correct-answer' | translate) }}
            </button>

            <button
                class="inline-flex items-center gap-2 px-5 py-2.5 rounded-full border text-sm font-semibold text-white transition-colors bg-secondary-500"
                *ngIf="hasAnswerOptions && (status !== 'validate' || questionSession.doneAt === null)" (click)="validate()">
                <div class="lds-ring" *ngIf="loading">
                    <div></div>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>

                <span>{{ 'player.question.button.validate' | translate }}</span>
            </button>

            <msc-next-prev-btn *ngIf="status === 'validate' && questionSession.doneAt" [doneAt]="questionSession.doneAt"
                [lastQuestion]="lastQuestion" [type]="'question'"></msc-next-prev-btn>
        </div>
    </div>
</div>

<!-- Footer (Debate / Notas) ocultado en vistas de question -->
<!-- <app-footer [context]="'question'" [contextId]="question?.id"></app-footer> -->

<style>
    .feedback__media {
        float: none !important;
    }

    .m-question-title {
        color: #424667 !important;
        font-size: 29px !important;
        font-weight: 600 !important;
        line-height: 2rem !important;
    }

    .feedback__text hr {
        display: none !important;
    }

    .feedback__text img {
        display: none !important;
    }

    .feedback__text span {
        font-size: 0.875rem !important;
        margin-left: 0 !important;
        font-weight: 600 !important;
    }
</style>